<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-sm-12">
                <b-card>
                    <div slot="header">
                        <strong>{{ $t('NEWRULECATEGORY') }}</strong>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <b-form-fieldset v-bind:label="$t('NAME')">
                                <inputvalidation :formerror="formError" name="name"><b-form-input type="text"
                                        v-model="formData.name" v-bind:placeholder="$t('NAME')"></b-form-input>
                                </inputvalidation>
                            </b-form-fieldset>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <b-form-fieldset v-bind:label="$t('ACTIVE')">
                                <inputvalidation :formerror="formError" name="endTime"><b-form-checkbox
                                        v-model="formData.active" value="1" unchecked-value="0"></b-form-checkbox>
                                </inputvalidation>
                            </b-form-fieldset>
                        </div>
                    </div>
                    <div slot="footer">
                        <p class="bg-danger" v-if="formError.error && typeof formError.notice == 'string'">
                            {{ formError.notice }}</p>
                        <b-button type="submit" size="sm" variant="primary" v-on:click.prevent="save(formData)"><i
                                class="fa fa-dot-circle-o"></i> {{ $t('SUBMIT') }}</b-button>
                    </div>
                </b-card>
            </div><!--/.col-->
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-align-justify"></i> {{ $t('RULECATEGORIES') }}
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-3">
                                <b-form-fieldset v-bind:label="$t('SEARCH')">
                                    <b-form-input v-model="pagination.query"></b-form-input>
                                </b-form-fieldset>
                            </div>
                        </div>
                    </div>
                    <div class="card-body" v-if="typeof data.root == 'undefined' || !data.root.length">
                        <p class="center">{{ $t('NODATAFOUND') }}</p>
                    </div>
                    <div class="card-body" v-if="typeof data.root != 'undefined' && data.root.length">
                        <table class="table table-responsive-sm table-striped">
                            <thead>
                                <tr>
                                    <th>{{ $t('NAME') }}</th>
                                    <th>{{ $t('ACTIVE') }}</th>
                                    <th>{{ $t('RULES') }}</th>
                                    <th>{{ $t('SAVE') }}</th>
                                    <th>{{ $t('DELETE') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, i) in data.root" :key="i">
                                    <td><b-form-input type="text" v-model="item.name"
                                            v-bind:placeholder="$t('NAME')"></b-form-input></td>
                                    <td>
                                        <b-form-checkbox v-model="item.active" value="1"
                                            unchecked-value="0"></b-form-checkbox>
                                    </td>
                                    <td><router-link class="btn btn-sm btn-primary"
                                            :to="'/rules/' + item.ruleCategoryId + '/rules'">
                                            <icon name="calendar"></icon> {{ $t('RULES') }}
                                        </router-link></td>
                                    <td><b-button type="reset" size="sm" variant="primary" v-on:click.prevent="save(item)">
                                            <icon name="save"></icon> {{ $t('SAVE') }}
                                        </b-button></td>
                                    <td><b-button type="reset" size="sm" variant="danger"
                                            v-on:click.prevent="deleteRow(item.ruleCategoryId)">
                                            <icon name="ban"></icon> {{ $t('DELETE') }}
                                        </b-button></td>
                                </tr>
                            </tbody>
                        </table>
                        <nav>
                            <b-pagination align="center" :total-rows="parseInt(data.totalCount)"
                                v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Api from '@/api/RulesCategories';

export default {
    name: 'Rules',
    data()
    {
        return {
            data: {},
            formError: {},
            formData:
            {
                name: '',
                active: 1,
            },
            pagination:
            {
                query: '',
                currentPage: 1,
                limit: 20,
                searchTimeout: false,
            },
        };
    },
    created()
    {
        const me = this;
        me.getData();
    },
    methods:
    {
        async save(item)
        {
            const me = this;

            if (typeof item.ruleCategoryId !== 'undefined')
            {
                item.id = item.ruleCategoryId;
                delete (item.ruleCategoryId);
            }

            item.days = JSON.stringify(item.days);

            const val = await Api.save(item);

            if (val.error)
            {
                me.$notify.notice(val);
                me.formError = val;
            }
            else
            {
                me.$notify.notice(val);
                me.formError = {};
                me.getData();
            }
        },
        async getData()
        {
            const me = this;
            const data = await Api.selectRow(me.getParams);

            if (data.error && data.error === true)
            {
                me.$notify.notice(data);
                return;
            }

            for (const dat of data.root)
            {
                if (dat.days != null)
                {
                    dat.days = JSON.parse(dat.days);
                }
                else
                {
                    dat.days = [];
                }
            }

            me.data = data;
        },
        deleteRow(id)
        {
            const me = this;
            me.$store.commit('setModalAlert',
                {
                    text: me.$i18n.t('AREYOUSHURE'),
                    async btnAction()
                    {
                        const data = await Api.deleteRow({ id });
                        if (data.error && data.error === true)
                        {
                            me.$notify.error(data.notice);
                        }
                        else
                        {
                            me.$notify.success(data.notice);
                        }

                        me.getData();
                    },
                });
        },
    },
    watch:
    {
        'pagination.currentPage'()
        {
            const me = this;
            me.getData();
        },
        'pagination.query'()
        {
            const me = this;

            if (me.pagination.searchTimeout !== false)
            {
                clearTimeout(me.pagination.searchTimeout);
            }

            me.pagination.searchTimeout = setTimeout(() =>
            {
                me.getData();
                me.pagination.searchTimeout = false;
            }, 300);
        },
    },
    computed:
    {
        getParams()
        {
            const me = this;
            const data = { ...me.pagination };
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        },
    },
};
</script>
